import GridView from "./view";

const Grid = ({
  data = [],
}) => {
  return (
    <GridView
      data={data}
    />
  )
};

export default Grid;